<template>
  <div class="creative_canvas_studio_tm_section">
    <div class="creative_canvas_studio_tm_copyright">
      <div class="container">
        <div class="inner">
          <div class="left wow fadeInLeft" data-wow-duration="1s">
            <p>
              Developed with love by
              <a href="https://motioncodelabs.co.za" target="_blank">MotionCodeLabs</a>
              &copy; {{ new Date().getFullYear() }}
            </p>
          </div>
          <div class="right wow fadeInRight" data-wow-duration="1s">
            <p>I do not own any of the images used on this website; they are solely for demonstration purposes of my coding skills.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CopyrightComponent",
  components: {},
};
</script>
